<template>
  <div class="listmain ">
      <h1 class="firTitle">登录</h1>
    <p>头文件 OrionSDK+Account.h ，需要传入当前 app 的登录信息手机号。</p>
      <h3 class="sedTitle">OrionSDKDataSource</h3>

          <highlight-code lang="javascript">
          <span>
              - (void)checkVerifyCode {
    OVSBaseNetWork *request = [OVSBaseNetWork requestWithPath:@"Account/checkLogin"
                                                    andParams:@{ @"phone" : self.phoneNum,
                                                                  @"code" : self.hideTextField.text}];
    [request startGetRequestSuccess:^(NSDictionary *response) {
        if ([response[@"code"] integerValue] == 200) {
            [self loading];
            NSDictionary *loginInfo = @{ @"access_token": response[@"data"][@"access_token"],
                                        @"refresh_token": response[@"data"][@"refresh_token"],
                                           @"expires_in": response[@"data"][@"expires_in"]};
            [[OrionSDK shared] loginWithUserInfo:loginInfo completion:^(NSDictionary * _Nullable userInfo, NSError * _Nullable error) {
                if (!error) {
                    NSDictionary *dicData = [userInfo objectForKey:@"data"];
                    if (dicData) {
                        [OVSUserModel sharedInstance].mobileId = [dicData objectForKey:@"mobileId"];
                        [OVSUserModel sharedInstance].mobileDeviceId = [dicData objectForKey:@"mobileDeviceId"];
                    }
                    [OVSUserModel sharedInstance].isLogin = YES;
                    // after login
                    APIListTableViewController *apilist = [[APIListTableViewController alloc] init];
                    [self.navigationController pushViewController:apilist animated:YES];
                } else {
                    OVSComponet *alert = [OVSComponet sharedInstance];
                    [alert alertMessage:error.description];

                }
                [self dismisLoading];
            }];
        }
    } failure:^(NSError *error) {
        [self codeErrorAction];
        [[OVSComponet sharedInstance]alertMessage:[error userInfo][@"message"]];
    } withNetworkManager:[OVSNetworkManger sharedManager]];
}
          </span>
    </highlight-code>
      <h3 class="sedTitle">登出</h3>
      <highlight-code lang="javascript">
         <span>
             [[OrionSDK shared] logoutWithCompletion:^(NSError * _Nullable error) {
    if (!error) {
       // 退出
    }
}];
         </span>
      </highlight-code>

     <p></p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/IosLogin.vue